
export default {
  data() {
    return {
      isAddedProduct: false,
    };
  },
  props: {
    /**
     * The type of the item (product/treatment)
     * Possible values: 'P', 'T'
     */
    type: {
      type: String,
      required: true,
    },
    isAdded: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    overrideUrl: {
      required: false,
      default: null
    },
    overrideText: {
      required: false,
      default: null
    }
  },
  computed: {
    isDraft() {
      return this.$store.getters["cmsConfigHomepage/isDraftMode"];
    },
  },
  methods: {
    addToCart() {
      if (this.type == "T") {
        if (this.type == "P") {
          this.isAddedProduct = true;
          setTimeout(() => {
            this.isAddedProduct = false;
          }, 1000);
        }
        this.$emit("clickButton", {
          type: this.type,
        });
      }
    },
    overrideRedirect() {
      if (this.overrideUrl && this.overrideUrl != '') {
        window.open(this.overrideUrl, '_self')
      }
    }
  },
};
